
    <app-circle-btn edit (btnClicked)="btnEvent()">
      <app-add-icon></app-add-icon>
    </app-circle-btn>
  